<template>
  <el-card shadow="hover">
    <label slot="header">定位组件</label>
    <el-divider content-position="left">经纬度，地址，网格编码绑定</el-divider>
    <JLocation :latitude.sync="loacl.latitude" :longitude.sync="loacl.longitude" :address.sync="loacl.address" :gridCode.sync="loacl.gridCode"  />
    <el-divider content-position="left">定位选择</el-divider>
    <JLocation :latitude.sync="loacl1.latitude" :longitude.sync="loacl1.longitude" :address.sync="loacl1.address" :gridCode.sync="loacl1.gridCode" :scope="['350430102','350430400']" placeholder="点击触发定位弹窗"  />
    <el-divider content-position="left">只读</el-divider>
    <JLocation :latitude.sync="loacl.latitude" :longitude.sync="loacl.longitude" :address.sync="loacl.address" :gridCode.sync="loacl.gridCode" read-only  />
  </el-card>
</template>

<script>
import JLocation from "@/components/JComponents/JLocation/JLocation.vue";
export default {
  components: {
    JLocation
  },
  data() {
    return {
      loacl: {
        latitude: '26.82978932825847',
        longitude: '116.84314319679062',
        address: '建宁县濉溪镇濉溪镇濉溪镇',
        gridCode: '35043010000101',
      },
      loacl1: {
        latitude: '',
        longitude: '',
        address: '',
        gridCode: ''
      }
    }
  },
  created() {}
}
</script>

<style scoped>

</style>
